// import { Protect } from '@clerk/clerk-react'
import { PaginationData } from '@/defines/commonDefines'
import { RequestStatus, RequestType } from '@/defines/requestDefines'
import AlertService from '@/defines/service/alertService'
import { useUserStore } from '@/defines/store/userStore'
import { PlusIcon } from '@heroicons/react/24/outline'
import { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { graphql, useLazyLoadQuery } from 'react-relay'
import { useNavigate } from 'react-router-dom'
import type { requestCareQuery as RequestCareQueryType } from './__generated__/requestCareQuery.graphql'
import userImage from 'assets/user.png'

const RequestCareQuery = graphql`
query requestCareQuery($requesttype: [Int!], $insuranceid: String!, $queryStart: timestamptz!, $queryEnd: timestamptz!){
  insurance_request_log_connection(where: {requesttype: {_in: $requesttype}, insuranceid: {_eq: $insuranceid}, created_at: {_gte: $queryStart, _lte: $queryEnd}}) {
    edges {
      node {
        request_care_details {
          id
          otherrequirement
          patientname
          hospitalid
          excuterid
          excutedate
          desiredstartdate
          desiredenddate
          created_at
          addressdetail
          hospital {
            id
            images
            name
          }
        }
        recipient {
          id
          email
          imageurl
          last_seen
          name
        }
        requeststatus
        requesttype
        recipientid
        insuranceid
        id
        created_at
        caredetailid
        aiconsultdetailid
      }
    }
  }
}
`

interface RequestCareViewModel {
    aiconsultdetailid: number | null | undefined;
    caredetailid: number | null | undefined;
    created_at: any | null | undefined;
    id: string;
    insuranceid: string;
    recipient: {
        email: string | null | undefined;
        id: string;
        imageurl: string | null | undefined;
        last_seen: any;
        name: string;
    } | null | undefined;
    recipientid: string | null | undefined;
    request_care_details: {
        addressdetail: string | null | undefined;
        created_at: any;
        desiredenddate: any;
        desiredstartdate: any;
        excutedate: any | null | undefined;
        excuterid: string | null | undefined;
        hospitalid: number | null | undefined;
        id: string;
        otherrequirement: string | null | undefined;
        patientname: string;
        hospital: {
            id: string;
            images: ReadonlyArray<string> | null | undefined;
            name: string | null | undefined;
        } | null | undefined;
    } | null | undefined;
    requeststatus: number;
    requesttype: number;
}

export default function RequestCare() {
    const alertService = AlertService();
    const [paginationData] = useState({} as PaginationData);
    const insuranceData = useUserStore.getState().insuranceData;
    const navigate = useNavigate();
    const userId = useUserStore.getState().userData.id;
    const [data, setData] = useState([] as RequestCareViewModel[]);

    let queryStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    var queryEndDate = new Date(new Date(queryStartDate).setMonth(queryStartDate.getMonth() + 1));
    const requestCareData = useLazyLoadQuery<RequestCareQueryType>(
        RequestCareQuery,
        {
            requesttype: [RequestType.care],
            insuranceid: userId,
            queryStart: queryStartDate.toUTCString(),
            queryEnd: queryEndDate.toUTCString()
        },
    );

    useEffect(() => {
        console.log(requestCareData);
        if (requestCareData?.insurance_request_log_connection?.edges.length == 0) {
            return;
        }
        let list = [] as RequestCareViewModel[];
        requestCareData?.insurance_request_log_connection?.edges.forEach(item => {
            let forAdd = {} as RequestCareViewModel;
            if (item.node.request_care_details) {
                forAdd.request_care_details = {
                    addressdetail: item.node.request_care_details.addressdetail,
                    created_at: item.node.request_care_details.created_at,
                    desiredenddate: item.node.request_care_details.desiredenddate,
                    desiredstartdate: item.node.request_care_details.desiredstartdate,
                    excutedate: item.node.request_care_details.excutedate,
                    excuterid: item.node.request_care_details.excuterid,
                    hospitalid: item.node.request_care_details.hospitalid,
                    id: item.node.request_care_details.id,
                    otherrequirement: item.node.request_care_details.otherrequirement,
                    patientname: item.node.request_care_details.patientname,
                    hospital: null
                };

                if (item.node.request_care_details?.hospital) {
                    forAdd.request_care_details.hospital = {
                        id: item.node.request_care_details?.hospital.id,
                        images: item.node.request_care_details?.hospital.images,
                        name: item.node.request_care_details?.hospital.name,
                    };
                }
            }
            if (item.node.recipient) {
                forAdd.recipient = {
                    email: item.node.recipient.email,
                    id: item.node.recipient.id,
                    imageurl: item.node.recipient.imageurl,
                    last_seen: item.node.recipient.last_seen,
                    name: item.node.recipient.name,
                };
            }
            forAdd.id = item.node.id;
            forAdd.aiconsultdetailid = item.node.aiconsultdetailid;
            forAdd.caredetailid = item.node.caredetailid;
            forAdd.created_at = item.node.created_at;
            forAdd.insuranceid = item.node.insuranceid;
            forAdd.recipientid = item.node.recipientid;
            forAdd.requeststatus = item.node.requeststatus;
            forAdd.requesttype = item.node.requesttype;
            list.push(forAdd);
        });
        setData(list);
    }, [requestCareData])

    const addRequestCare = () => {
        console.log('insuranceData', insuranceData);
        if (insuranceData.remaincare <= 0) {
            alertService.Error('您已超過可使用數量 ! ');
            return;
        }
        navigate('/insurance/request-care/detail');
    }

    const redirectToDetail = (id: string) => {
        console.log('redirectToDetail', id);
        navigate(`/insurance/request-care/detail?id=${id}`);
    }

    return (

        <div className="flex justify-center items-center">
            {/* <Protect
                role="org:admin"
                fallback={<p>您並無相關權限</p>}
            > */}


            <div className="bg-white w-full">
                <div>
                    <main className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                        <div className="flex items-baseline justify-between pt-6 border-b border-gray-200">
                            <h1 className="text-4xl font-bold tracking-tight text-gray-900">
                                關懷需求
                            </h1>

                            <div>
                                <button
                                    onClick={() => addRequestCare()}
                                    type="button"
                                    className="inline-flex items-center gap-x-1.5 rounded-md 
                                                bg-teal-500 px-1 mt-2 text-lg font-semibold text-white 
                                                shadow-sm hover:bg-teal-400 focus-visible:outline focus-visible:outline-2 
                                                focus-visible:outline-offset-2 focus-visible:outline-teal-700"
                                >
                                    <PlusIcon
                                        aria-hidden="true"
                                        className="w-5 h-5"
                                    />
                                    增加關懷
                                </button>
                                <h1 className="text-sm tracking-tight text-gray-900">
                                    您尚餘 {insuranceData.remaincare} 個關懷
                                </h1>
                            </div>
                        </div>
                        <div className='flex items-baseline mt-2'>
                            <p className='text-sm'>僅顯示當月資料</p>
                        </div>

                        <section
                            aria-labelledby="products-heading"
                            className="pt-6 pb-24"
                        >
                            <div className="flex flex-row">

                                {/* Product grid */}
                                <div className="px-10 py-3 basis-full basis-full">

                                    <InfiniteScroll
                                        dataLength={data.length}
                                        next={() => {
                                            // loadData(true, paginationData.endCursor)
                                        }}
                                        scrollThreshold={'90%'}
                                        hasMore={paginationData.hasNextPage}
                                        loader={<h4>載入中...</h4>}
                                        endMessage={
                                            <p className='mt-12' style={{ textAlign: 'center' }}>
                                                <b>沒有更多資料了 ! </b>
                                            </p>
                                        }
                                    >
                                        {data.map((request) => (
                                            <li key={request.id} className="flex justify-between gap-x-6 py-5 cursor-pointer" onClick={() => { redirectToDetail(request.id) }}>
                                                <div className="flex min-w-0 gap-x-4">
                                                    <img alt="" src={request.recipient?.imageurl ?? userImage} className="size-12 flex-none rounded-full bg-gray-50" />
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm/6 font-semibold text-gray-900">
                                                            {request.request_care_details?.patientname ?? request.recipient?.name ?? "尚未指定病患"}
                                                        </p>
                                                        <p className="mt-1 flex text-xs/5 text-gray-500">
                                                            醫療院所: {request.request_care_details?.hospital?.name}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex shrink-0 items-center gap-x-6">
                                                    <div className="hidden sm:flex sm:flex-col sm:items-end">
                                                        <p className="text-sm/6 text-gray-900">{RequestStatus[request.requeststatus]}</p>
                                                        <p className="mt-1 text-xs/5 text-gray-500">
                                                            期望時間 {new Date(request.request_care_details?.desiredstartdate).toLocaleString()} ~
                                                            {new Date(request.request_care_details?.desiredenddate).toLocaleString()}
                                                        </p>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </InfiniteScroll>


                                </div>
                            </div>
                        </section>
                    </main>
                </div>
            </div>
            {/* </Protect > */}
        </div>


    )
}